<template>
  <div class="good-item cursor-pointer" @click="goDetail">
    <div class="g-img">
      <img :src="item.goodsImg" v-show="item.goodsImg" />
      <img src="~@/assets/img/bitmap.png" v-show="!item.goodsImg" />
    </div>
    <div class="ellipsis good-spu-title line-break">
      <Tooltip :innerContent="item.name" />
    </div>
    <div class="ellipsis good-spu-brand line-break">
      {{ $t('common.brand') }}：<Tooltip
        :innerContent="item.brandName || '-'"
      />
    </div>
    <div class="spu-code">
      {{ $t('product.supplyCommodityCode') }}：<Tooltip
        :innerContent="item.code || '-'"
      />
    </div>
    <div class="goquery">
      <img width="96px" :src="require('@/assets/img/goquiry.png')" />
    </div>
  </div>
</template>

<script>
import Tooltip from '@/components/tooltipShow/index'
import { openOther } from '@/utils'
export default {
  components: {
    Tooltip
  },
  props: ['item'],
  data () {
    return {}
  },

  methods: {
    // 跳转详情页
    goDetail () {
      openOther(`selectionInquiryDetail?spuId=${this.item.spuId}&skuId=`)
    }
  }
}
</script>

<style lang="scss" scoped>
.good-item {
  user-select: none;
  text-align: center;
  position: relative;
  background: #fff;
  height: 274px;
  padding: 12px;
  border-radius: 12px;
//   -webkit-box-shadow: rgba(0, 0, 0, 0.07) 0px 3px 9px 0;
//   -moz-box-shadow: rgba(0, 0, 0, 0.07) 0px 3px 9px 0;
//   box-shadow: rgba(0, 0, 0, 0.07) 0px 3px 9px 0;

  &:hover {
    -webkit-box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.14);
    -moz-box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.14);
    box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.14);
    z-index: 1;
  }

  > img {
    margin-bottom: 24px;
  }

  .price_text {
    font-size: 20px;
  }
  /deep/ .price {
    margin-top: 10px;
    color: #e64c3a;
    font-weight: bold;
    .price-int {
      font-size: 20px;
    }
    .price-point {
      font-size: 10px;
    }
  }
  .good-spu-title {
    color: #333333;
    line-height: 22px;
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    color: #1a1a1a;
  }
  .good-spu-brand {
    display: flex;
    margin-top: 8px;
    font-size: 12px;
    line-height: 16px;
    color: #646566;
    text-align: left;
    padding-right: 80px;
  }
  .spu-code {
    display: flex;
    margin-top: 8px;
    font-size: 12px;
    line-height: 16px;
    color: #646566;
    text-align: left;
  }
  .g-img {
    width: 100%;
    height: 157px;
    margin-bottom: 23px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .goquery {
    display: flex;
    position: absolute;
    right: 12px;
    bottom: 12px;
  }
}
</style>
